export default "/assets/images/air3-nav-menu.1b8a7eea6e4fa6bf.webp";